(function () {
  if (window.__dsStickyGuard) return;
  window.__dsStickyGuard = true;
  var footer = document.querySelector('.shopify-section-group-footer-group, footer');
  if (!footer || !('IntersectionObserver' in window)) return;
  var root = document.documentElement;
  new IntersectionObserver(function (entries) {
    var visible = entries[entries.length - 1].isIntersecting;
    if (visible) root.setAttribute('data-ds-near-footer', '');
    else root.removeAttribute('data-ds-near-footer');
  }, { threshold: 0 }).observe(footer);
})();
